import styled from 'styled-components'

export const Paragraph = styled.p`
    margin-bottom: 0;
    padding-bottom: 0;
    font-size: 12px;
    margin-right: 10px;
    margin-left: 15px;
`
